export default "__VITE_ASSET__DHcMwY7K__"